import { createAxiosInstance } from '@speechki-frontend/shared/axios';

import { normalizeBookparts } from './utils';

const BASE_URL = process.env.VUE_APP_BASE_URL;
const prefix = `/api/v2`;
const URL = BASE_URL + prefix;

const axios = createAxiosInstance(BASE_URL, { enableGuestAccess: true, rejectOn5xx: true });

export const fetchBookparts = (book, params = {}) => {
    if (!book) {
        throw new Error('Bookparts: bookId is undefined');
    }

    return axios.get(`${URL}/book_parts/`, {
        params: {
            book,
            ...params
        }
    });
};

export const fetchBookpartsPage = (book, page, params = {}) => {
    return fetchBookparts(book, { page, ...params });
};

export const fetchNormalizedBookparts = async (book, params = {}) => {
    if (!book) {
        throw new Error('Bookparts: bookId is undefined');
    }

    const { results = [], count: bookpartsCount = 0 } = await axios.get(URL + '/book_parts/', {
        params: {
            ...params,
            book
        }
    });

    const { bookparts, bookpartsList } = normalizeBookparts(results);

    return {
        bookparts,
        bookpartsList,
        bookpartsCount
    };
};

export const fetchNormalizedBookpartsPage = async (book, pageNum, params = {}) => {
    const page = await fetchNormalizedBookparts(book, {
        ...params,
        page: pageNum
    });
    page.id = pageNum;

    return page;
};

export const fetchRandomBookparts = async (book, params = {}) => {
    return axios.get(`${URL}/books/${book}/random_parts/`, { params });
};

export const fetchSamples = (book, params = {}) => {
    return fetchBookparts(book, { is_sample_flag: true, page_size: 199, ...params });
};

export const clearSamples = (book, params = {}) => {
    return axios.put(`${URL}/books/${book}/remove_sample_flags/`, { params });
};

export const searchBookparts = (book, query, params = {}) => {
    return axios.get(`${URL}/books/${book}/search/`, {
        params: {
            search_part: query,
            ...params
        }
    });
};

export const fetchBrokenParts = (book, params = {}) => {
    return axios.get(`${URL}/books/${book}/broken_parts/`, { params });
};

export const fetchEmptyParts = (book, params = {}) => {
    return axios.get(`${URL}/books/${book}/empty_parts/`, { params });
};

export const reindexEmptyParts = (book, params = {}) => {
    return axios.post(`${URL}/books/${book}/reindex_empty_parts/`, { params });
};

export const mergeBookparts = (subject, target, params = {}) => {
    return axios.put(
        `${URL}/book_parts/${subject}/gluing/`,
        {
            target
        },
        { params }
    );
};

export const fetchTextTypes = (params = {}) => {
    return axios.get(`${URL}/book_parts/text_types/`, { params });
};

export const getCurrentTiming = (id, params = {}) => {
    return axios.post(`${URL}/books/${id}/current_timing/`, params);
};

export const fetchBookpartsChanges = (book, params = {}) => {
    return axios.get(`${URL}/admin/book/books/${book}/book_parts_changes/`, { params });
};

export const changeBookPartsSpeaker = (bookId, data) => {
    return axios.post(`${URL}/books/${bookId}/change_book_parts_speaker/`, data);
};

export const fetchSwapPartTypes = (params = {}) => {
    return axios.get(`${URL}/book_parts/swap_part_types/`, params);
};

export const addBookparts = (book, data, params = {}) => {
    return axios.post(`/api/v2/books/${book}/add_sentences/`, data, { params });
};
